export type LoadingAppState = Readonly<{ loadingCount: number }>

export const selectIsLoading = (s: LoadingAppState): boolean => s.loadingCount > 0
